import {
  PLAN_STANDARD,
  PLAN_PRO_KITCHEN,
  PLAN_ELITE_KITCHEN,
  getPlanDisplayName,
  getPlanPrice,
} from "../subscription/planFeatures";
import { createOrGetProduct } from "./stripeClient";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

const STRIPE_PRODUCTS_COLLECTION = "stripeProducts";

export const initializeStripeProducts = async (storeId: string): Promise<void> => {
  const plans = [
    { id: PLAN_STANDARD, name: getPlanDisplayName(PLAN_STANDARD), price: getPlanPrice(PLAN_STANDARD) },
    { id: PLAN_PRO_KITCHEN, name: getPlanDisplayName(PLAN_PRO_KITCHEN), price: getPlanPrice(PLAN_PRO_KITCHEN) },
    { id: PLAN_ELITE_KITCHEN, name: getPlanDisplayName(PLAN_ELITE_KITCHEN), price: getPlanPrice(PLAN_ELITE_KITCHEN) },
  ];

  for (const plan of plans) {
    try {
      const productDocRef = doc(db, STRIPE_PRODUCTS_COLLECTION, plan.id);
      const productDoc = await getDoc(productDocRef);

      if (productDoc.exists()) {
        console.log(`✅ Stripe product for ${plan.id} already exists`);
        continue;
      }

      const stripeProduct = await createOrGetProduct(storeId, plan.id, plan.name, plan.price);

      if (!stripeProduct) {
        console.error(`❌ Failed to create Stripe product for ${plan.id}`);
        continue;
      }

      await setDoc(productDocRef, {
        planId: plan.id,
        planName: plan.name,
        price: plan.price,
        stripeProductId: stripeProduct.productId,
        stripePriceId: stripeProduct.priceId,
        createdAt: new Date(),
      });

      console.log(`✅ Created Stripe product for ${plan.id}: ${stripeProduct.productId}`);
    } catch (error) {
      console.error(`❌ Error initializing Stripe product for ${plan.id}:`, error);
    }
  }
};

export const getStripeProductIds = async (
  planId: string
): Promise<{ productId: string; priceId: string } | null> => {
  try {
    const productDocRef = doc(db, STRIPE_PRODUCTS_COLLECTION, planId);
    const productDoc = await getDoc(productDocRef);

    if (!productDoc.exists()) {
      console.warn(`⚠️ Stripe product not found for plan: ${planId}`);
      return null;
    }

    const data = productDoc.data();
    return {
      productId: data.stripeProductId,
      priceId: data.stripePriceId,
    };
  } catch (error) {
    console.error(`❌ Error getting Stripe product IDs for ${planId}:`, error);
    return null;
  }
};

